import PropTypes from 'prop-types';
import { memo } from 'react';
// @mui
import { Stack } from '@mui/material';
//
import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

const hideScrollbar = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

NavSectionHorizontal.propTypes = {
  navConfig: PropTypes.array.isRequired,
  user: PropTypes.object,
};

function NavSectionHorizontal({ navConfig, user }) {
  const filteredNavConfig = navConfig.map((group) => ({
    ...group,
    items: group.items.filter((item) => (user ? item.loggedIn : item.loggedOut)),
  }));

  return (
    <Stack direction="row" justifyContent="center" sx={{ px: 0.5 }}>
      <Stack direction="row" sx={{ ...hideScrollbar, py: 1 }}>
        {filteredNavConfig.map((group, key) => (
          <Stack key={group.subheader + key.toString()} direction="row" flexShrink={0}>
            {group.items.map((list) => (
              <NavListRoot key={list.title + list.path} list={list} />
            ))}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}

export default memo(NavSectionHorizontal);
